import { render } from "./CoverageDetails.vue?vue&type=template&id=3bb22fc2"
import script from "./CoverageDetails.vue?vue&type=script&lang=js"
export * from "./CoverageDetails.vue?vue&type=script&lang=js"

import "./CoverageDetails.vue?vue&type=style&index=0&id=3bb22fc2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__